<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    viewBox="0 0 97.5 97.5"
  >
    <path
      d="M95.5 62.844h-6.164V58.84c0-7.135-5.804-12.938-12.938-12.938H52.445V34.656h6.088a2 2 0 0 0 2-2V13.09a2 2 0 0 0-2-2H38.967a2 2 0 0 0-2 2v19.566a2 2 0 0 0 2 2h6.087v11.245H21.103c-7.135 0-12.938 5.804-12.938 12.938v4.004H2a2 2 0 0 0-2 2V84.41a2 2 0 0 0 2 2h19.566a2 2 0 0 0 2-2V64.844a2 2 0 0 0-2-2h-6.009V58.84a5.55 5.55 0 0 1 5.545-5.545h23.951v9.549h-6.087a2 2 0 0 0-2 2V84.41a2 2 0 0 0 2 2h19.566a2 2 0 0 0 2-2V64.844a2 2 0 0 0-2-2h-6.087v-9.549h23.951a5.55 5.55 0 0 1 5.545 5.545v4.004h-6.01a2 2 0 0 0-2 2V84.41a2 2 0 0 0 2 2H95.5a2 2 0 0 0 2-2V64.844a2 2 0 0 0-2-2z"
    />
  </svg>
</template>